module.exports = __webpack_public_path__ + "img/7house10.fdc05df7.jpg";